<div #step2 class="ui-g">

  <div class="ui-g-12">
    <p-messages [(value)]="errors"></p-messages>
  </div>

  <div class="ui-g-12 ui-lg-6">
    <div class="card left">
      <app-drag-and-drop-list 
      [channels]=channels 
      [channelPriorities]="channelPriorities" 
      [savedPriorities] = "savedPriorities"
      (priorityListChanged)="priorityChangedHandler($event)"
      ></app-drag-and-drop-list>
      <div class="ui-g-12 campaign-switch-container">
        <p-inputSwitch [(ngModel)]="flagAllSelectedChannels"></p-inputSwitch>
        <span class="input-text">{{ 'campaign.allSelectedChannelsLabel' | translate }}</span>
      </div>
    </div>
  </div>

  <div class="ui-g-12 ui-lg-6">
    <div class="card left">

      <div class="ui-g form-group master-data">

        <div class="ui-g-12">
          <div class="ui-g-12">
            <div class="subtitle">
              <div class="campaign-sub">{{ 'campaign.emission' | translate }}</div>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6">
            <div class="start">{{ 'campaign.startDate' | translate }}</div>
            <p-calendar
              *ngIf="calendarTranslate"
              [(ngModel)]="campaign.emissionStartDate"
              [showIcon]="true"
              [locale]="calendarTranslate"
              [minDate]="today"
              [dateFormat]="calendarTranslate.dateFormat"
              [placeholder]="calendarTranslate.dateFormat"
              [readonlyInput]="true"
              (onSelect)="emissionDateSelect()"
            ></p-calendar>
          </div>
          <div class="ui-g-12 ui-md-6">
            <div class="start">{{ 'campaign.endDate' | translate }}</div>
            <p-calendar
              *ngIf="calendarTranslate"
              [(ngModel)]="campaign.emissionEndDate"
              [showIcon]="true"
              [locale]="calendarTranslate"
              [minDate]="campaign.emissionStartDate"
              [dateFormat]="calendarTranslate.dateFormat"
              [placeholder]="calendarTranslate.dateFormat"
              [readonlyInput]="true"
              (onSelect)="checkDates()"
            ></p-calendar>
          </div>
        </div>

        <div class="ui-g-12">
          <div class="ui-g-12">
            <div class="subtitle">
              <div class="campaign-sub">{{ 'campaign.redemption' | translate}}</div>
            </div>
          </div>

          <div class="ui-g-12 ui-md-6">
            <div class="start">{{ 'campaign.startDate' | translate }}</div>
            <p-calendar
              *ngIf="calendarTranslate"
              [(ngModel)]="campaign.redemptionStartDate"
              [showIcon]="true"
              [locale]="calendarTranslate"
              [minDate]="campaign.emissionStartDate"
              [dateFormat]="calendarTranslate.dateFormat"
              [placeholder]="calendarTranslate.dateFormat"
              [readonlyInput]="true"
              (onSelect)="redemptionDateSelect()"
            ></p-calendar>
          </div>
          <div class="ui-g-12 ui-md-6">
            <div class="start">{{ 'campaign.endDate' | translate }}</div>
            <p-calendar
              *ngIf="calendarTranslate"
              [(ngModel)]="campaign.redemptionEndDate"
              [showIcon]="true"
              [locale]="calendarTranslate"
              [minDate]="campaign.redemptionStartDate"
              [dateFormat]="calendarTranslate.dateFormat"
              [placeholder]="calendarTranslate.dateFormat"
              [readonlyInput]="true"
              (onSelect)="checkDates()"
            ></p-calendar>
          </div>
        </div>

        <div class="ui-g-12">
          <div class="ui-g-12 campaign-switch-container">
            <p-inputSwitch [(ngModel)]="campaign.flagOnlyCardHolder"></p-inputSwitch>
            <span class="input-text">{{ 'campaign.cardHolderLabel' | translate }}</span>
          </div>
          <div class="ui-g-12 campaign-switch-container">
            <p-inputSwitch [(ngModel)]="campaign.flagOnlyLoyaltyCard"></p-inputSwitch>
            <span class="input-text">{{ 'campaign.loyaltyCardLabel' | translate }}</span>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-2/campaign-step-2.html